module.exports = __webpack_public_path__ + "static/media/image_8.bf3af9bb.png";